import { Icon } from './types';

export const GlobeAlternativeIcon: Icon = (props) => (
  <svg
    viewBox={'0 0 24 24'}
    id={'globe-alternative'}
    xmlns={'http://www.w3.org/2000/svg'}
    {...props}
  >
    <path
      d={
        'M12 .069c6.628 0 12 5.372 12 12s-5.372 12-12 12-12-5.372-12-12 5.372-12 12-12Zm0 22.5c.783 0 1.894-.675 2.902-2.686.464-.928.853-2.09 1.087-3.314H7.97c.276 1.223.665 2.386 1.13 3.314 1.007 2.011 2.118 2.686 2.901 2.686Zm-4.298-7.5h8.596c.132-.947.202-1.955.202-3s-.07-2.053-.202-3H7.702a21.923 21.923 0 0 0-.202 3c0 1.045.07 2.053.202 3Zm8.287-7.5a12.574 12.574 0 0 0-1.087-3.315C13.894 2.243 12.782 1.57 12 1.57c-.783 0-1.894.674-2.902 2.685-.464.929-.853 2.05-1.13 3.315h8.021Zm1.781 1.5c.164.96.23 1.964.23 3s-.066 2.039-.23 3h4.294c.286-.952.436-1.96.436-3s-.15-2.049-.436-3H17.77Zm-2.418-6.953c.984 1.327 1.762 3.222 2.212 5.453h3.924a10.517 10.517 0 0 0-6.136-5.453Zm-6.704 0a10.53 10.53 0 0 0-6.137 5.453h3.925c.45-2.231 1.228-4.125 2.212-5.453ZM1.5 12.069c0 1.04.152 2.048.435 3h4.252a23.862 23.862 0 0 1-.187-3c0-1.036.066-2.04.188-3H1.934c-.283.951-.435 1.96-.435 3Zm19.988 4.5h-3.924c-.45 2.231-1.228 4.125-2.212 5.451a10.504 10.504 0 0 0 6.136-5.451Zm-15.052 0H2.51a10.518 10.518 0 0 0 6.137 5.451c-.984-1.326-1.762-3.22-2.212-5.451Z'
      }
    />
  </svg>
);
